import { hasAccess } from 'utils/access';

// Explicit ERP grants take precedence over the old profile flags.
const legacyReadAccess = user => !user?.erp_role && !user?.erp_access && !!(user?.is_admin_of || user?.is_report_of);

export const canReadLoadQueues = user => hasAccess(user, 'loads') || hasAccess(user, 'reports') || legacyReadAccess(user);
export const canReadDriverDocuments = user => ['drivers', 'drivers_edit', 'drivers_pin', 'drivers_block', 'requests', 'confirmations'].some(key => hasAccess(user, key)) || legacyReadAccess(user);
export const canReadLoadPhotos = user => canReadLoadQueues(user) || ['guard', 'operator', 'base_operator'].includes(user?.erp_role);
export const canReadBlockedDrivers = user => hasAccess(user, 'drivers_block') || legacyReadAccess(user);
